import type { OrderedMap } from '@gonfalon/immutable-shim/immutableShim';

import type { Environment } from '#utils/environments/records/Environment';
import type { Project } from '#utils/projects/records/Project';

import { getProjAndEnvKeysFromSelfLink } from './getProjAndEnvKeysFromSelfLink';

export const getProjAndEnvFromSelfLink = (
  projects: OrderedMap<string, Project>,
  environments: OrderedMap<string, Environment>,
  link: string,
) => {
  if (!link) {
    return {};
  }
  const [projKey, envKey] = getProjAndEnvKeysFromSelfLink(link);
  if (projKey && envKey) {
    const proj = projects.get(projKey);
    const matchingEnvs = environments.filter((e) => e.key === envKey);
    if (proj) {
      const env = matchingEnvs.find((e) => proj.environments.includes(e._id));
      if (env) {
        return { proj, env };
      }
    }
  }
  return {};
};
